import { atom, useAtom } from 'jotai';

export type NavPage = 'emails' | 'products' | 'discounts' | 'audience' | 'analytics';

const navPageAtom = atom<NavPage>('emails');

export function useNavPage() {
  return useAtom(navPageAtom);
}
